import { connect } from 'react-redux'

import component from 'components/Products'

const mapActionCreators = {
}

const mapStateToProps = (state) => ({
  products: state.products,
  types: state.types,
  categories: state.categories
})

export default connect(mapStateToProps, mapActionCreators)(component)



// WEBPACK FOOTER //
// ./src/routes/Products/containers/ProductsContainer.js